import React, { useEffect, useState } from 'react';
import './style.less';
import { LocaleString } from '@nackle/intl-tools';
import solutionFetch from './solution';
import contentFetch from './content';
import test from './preference';
/* eslint-disable */
import regeneratorRuntime from 'regenerator-runtime';
import { env } from '@nackle/eslint-config';
/* eslint-enable */
const App = ( { ssoEndpoint, identity, environment, celebrationYes, celebrationNo, celebrationInfo, locale, accessToken } ) => {
    const [ solution, setSolution ] = useState();
    const [ contentFetched, setContentFetched ] = useState( false );
    const [ fetchedOptoutPreference, setFetchedOptoutPreference ] = useState( true );
    const [ localOptoutPreference, setLocalOptoutPreference ] = useState( null );
    const [ isFiring, setIsFiring ] = useState ( false );
        useEffect( () => {
            async function getSolutionAndContent() {
                const fetched = await solutionFetch( accessToken, environment, identity );
                const content = await contentFetch( accessToken, environment, locale );
                const preference = await test.getOptoutPreference( accessToken, environment );
                setLocalOptoutPreference( preference );
                setSolution( fetched );
                setLocalOptoutPreference( preference || false );


                if ( content && content.success ) {
                    setContentFetched( true );
                }
            }
            if ( !solution ) {
                getSolutionAndContent();
            }
          }, [] );

        //Set preference when new option is selected
        useEffect( () => {
        const updatePreference = async () => {

            if ( isFiring === true || localOptoutPreference === null ) {
                return;
            }
            setIsFiring( true );
            const fetchedPreference = await test.setOptoutPreference( accessToken, environment, localOptoutPreference );
            setIsFiring( false );
            setFetchedOptoutPreference( fetchedPreference );
            
        };
        updatePreference();
        }, [ localOptoutPreference ] );

        //After setting a preference, check if the user has updated their selection since the request was fired
        //If they have, set it again.
        useEffect ( () => {
        const updateDirtyPreference = async () => {
            if ( isFiring === true || localOptoutPreference === null ) {
                return;
            }
            setIsFiring( true );
            const fetchedPreference = await test.setOptoutPreference( accessToken, environment, localOptoutPreference );
            setIsFiring( false );
            setFetchedOptoutPreference( fetchedPreference );
        };
        if ( localOptoutPreference !== fetchedOptoutPreference ) {
            updateDirtyPreference();
        }
        }, [ fetchedOptoutPreference ] );

        async function updateOptoutPreference ( value ) {
            setLocalOptoutPreference( value );
        }

        return (
            <div className="control-group validateme" data-validate-flags="nonempty">
                {
                    contentFetched &&
                    <>
                    <label className="radio" htmlFor="allowCelebrationYes">
                        <input type="radio" id="allowCelebrationYes" name="allowCelebration" value="false" checked={ localOptoutPreference === false } onClick={ () => updateOptoutPreference( false ) }/>
                        { celebrationYes || <LocaleString code="celebration.preferences.yes" /> } 
                        <i id="celebrationInfoIcon" tabIndex="0" className="icon-info"></i>
                        <div id="celebrationInfoPopup" className="hiddenTooltip" > { celebrationInfo || <LocaleString code="celebration.preferences.tooltip" /> } </div>
                    </label>
                    <label className="radio" htmlFor="allowCelebrationNo">
                        <input type="radio" id="allowCelebrationNo" name="allowCelebration" value="true" checked={ localOptoutPreference === true } onClick={ () => updateOptoutPreference( true ) }/>
                        { celebrationNo || <LocaleString code="celebration.preferences.no" /> }
                    </label>
                    </>
                }
            </div>
        );
};
export default App;